<template>
    <div :style="'position:absolute;right:10px;top:-3px;' + style_str ">
        <img ref="help_img" :src="help_img">
    </div>
</template>

<script>
import help_img from '~pic/help.png';
import {msgbox} from '~js/smallarAlert.esm.js';
export default {
    name:'Help',
    props:{
        // title:String,
        help_msg:String,
        style_str:String,
    },
    mounted() {
        this.$refs.help_img.addEventListener('click',()=>{
            msgbox({
                type:'alert',
                title:this.title,
                msg:this.help_msg
            })
        })
    },
    data(){
        return {
            title:'帮助',
            // help_msg:'帮助字符串',
            help_img,

        }
    }
}
</script>

<style lang="stylus" scoped>


</style>
